module.exports = __webpack_public_path__ + "img/redLogo.8c508d86.png";